import { render } from "./loginSimple.vue?vue&type=template&id=42235469"
import script from "./loginSimple.vue?vue&type=script&lang=js"
export * from "./loginSimple.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__